import { User } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

import { SnapshotFn } from './type';

export default function customerListener(platformId: string, auth: User, onNext: SnapshotFn) {
  const ref = doc(firestore, 'platforms', platformId, 'customers', auth.uid);

  return onSnapshot(ref, {
    next: onNext,
    error: () => {
      console.error(`listen platforms customer error`);
    },
  });
}
